/* global history */
/* global location */
/* global window */

import Constants from 'constants';
import APP from 'app';

//const { compileHash, parseRoute } = APP.routerUtils.compileHash,

const pushState = (route) => {
    try {
        const path = APP.RouterUtils.compileHash(route);
        if (window.location.pathname + window.location.search !== path) {
            window.history.pushState({ route }, '', path);
        }
    } catch (error) {
        window.console.error(error);
    }
},

    navigateTo = (route) => {
        pushState(route);
        return {
            type: Constants.actions.ROUTER.CHANGE_ROUTE,
            route,
        };
    },

    navigateBack = (e) => {
        return (dispatch) => {
            const { state } = e;
            if (state) {
                const { route } = state;
                dispatch(navigateTo(route, false));
            }
        };
    },


    initRouter = (paths) => {
        return (dispatch) => {
            window.onpopstate = (e) => {
                dispatch(navigateBack(e));
            };
            const path = window.location.pathname + window.location.search,
                route = APP.routerUtils.parseRoute(path, paths);
            return dispatch(navigateTo(route));
        };
    },

    clearStateData = () => {
        return {
            type: actionTypes.ROUTER.RESET_STATE_DATA
        };
    };

export {
    pushState,
    navigateTo,
    navigateBack,
    initRouter,
    clearStateData
};
